import { AnimateMotion } from "../AnimateMotion";
import { Sidebar as SidebarWrapper } from "@/components/layout/Sidebar";
import { VisualArea as VisualAreaWrapper } from "@/components/layout/VisualArea";
import { VisualAreaBottom as VisualAreaBottomWrapper } from "@/components/layout/VisualAreaBottom";
import { FlowStepper } from "./FlowStepper";

export const StepsLayout = ({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) => {
    return (
        <AnimateMotion className="h-full w-full bg-gray-50">
            <div className="relative flex h-full flex-col">
                <FlowStepper />
                <div className="relative flex h-[calc(100vh-6rem)] w-full min-w-0 flex-col md:flex-row">
                    <div className="relative flex h-full min-w-0 flex-1 flex-col px-3 pb-1 md:p-0">
                        <div className="relative flex h-full min-w-0 flex-1">
                            <VisualAreaWrapper>{VisualArea}</VisualAreaWrapper>
                        </div>
                        {BottomContent && (
                            <div className="relative w-screen md:w-full">
                                <VisualAreaBottomWrapper>{BottomContent}</VisualAreaBottomWrapper>
                            </div>
                        )}
                    </div>
                    <SidebarWrapper>{Sidebar}</SidebarWrapper>
                </div>
            </div>
        </AnimateMotion>
    );
};

export const ShareStepsLayout = ({
    VisualArea,
    BottomContent
}: {
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) => {
    return (
        <AnimateMotion className="h-full w-full overflow-y-hidden bg-gradient-to-b from-white to-purple-100 md:p-6">
            <div className="mx-auto flex h-full w-full max-w-7xl flex-col md:rounded-2xl md:bg-black md:bg-opacity-5 md:backdrop-blur-lg">
                <VisualAreaWrapper>{VisualArea}</VisualAreaWrapper>
                {BottomContent && (
                    <div className="relative w-screen md:w-full">
                        <VisualAreaBottomWrapper>{BottomContent}</VisualAreaBottomWrapper>
                    </div>
                )}
            </div>
        </AnimateMotion>
    );
};
